import './panel.css';

const Autodesk = window.Autodesk;

export class BasePanel extends Autodesk.Viewing.UI.DockingPanel {
    constructor(viewer, container, id, title, options) {
        super(container, id, title, options);

        this.viewer = viewer;
    }

    toggleVisibility() {
        this.setVisible(!this.isVisible());
    }

    initialize() {
        this.container.style.top = '10px';
        this.container.style.left = '10px';
        this.container.style.minWidth = '200px';
        this.container.style.width = '400px';
        this.container.style.height = 'auto';
        this.container.style.resize = 'horizontal';

        // title bar
        this.titleBar = this.createTitleBar(this.titleLabel || this.container.id);
        this.container.appendChild(this.titleBar);

        // close button
        this.closeButton = this.createCloseButton();
        this.container.appendChild(this.closeButton);

        // the main content area
        this.mainDiv = document.createElement('div');
        this.container.appendChild(this.mainDiv);

        // allow move
        for (const movableEl of this.container.querySelectorAll('.movableArea')) {
            this.initializeMoveHandlers(movableEl);
        }
        this.initializeMoveHandlers(this.titleBar);
        this.initializeMoveHandlers(this.closeButton);
    }

    getRenderNode() {
        return this.mainDiv;
    }
}
